import { type ReactNode, Suspense } from 'react';
import { Card } from 'react-bootstrap';

import { type DOI } from '../utils/doi';
import { Loading } from '../utils/Loading';
import { DOILoadReference } from './DOILoadReference';

export interface DOIReferenceProps {
  doi: DOI;
  children: ReactNode;
}

export function DOIReference({ doi, children }: DOIReferenceProps) {
  return (
    <Card>
      <Card.Header className="p-2">Reference</Card.Header>
      <Card.Body className=" p-2">
        <p className="mb-2" style={{ maxWidth: '60em' }}>
          {children}
        </p>

        <Suspense fallback={<Loading />}>
          <DOILoadReference doi={doi.doi} copy />
        </Suspense>
      </Card.Body>
    </Card>
  );
}
